import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import App from './containers/app.js'
import reducers from './reducers';

const createStoreWithMiddleware = applyMiddleware(thunk)(createStore);

const root = document.getElementById('search_form_root');

if (root) {
    ReactDOM.render(
    <Provider store={createStoreWithMiddleware(reducers,window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__({name:'Search'}))}>
        <App selectedCategory={SELECTED_CATEGORY} selectedVehicle={SELECTED_VEHICLE}/>
    </Provider>
        ,root
);
}

